var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item-button',{staticClass:"export",on:{"click":function($event){return _vm.exportCSV()}}},[_vm._v(_vm._s(_vm.$t('general.buttons.exportCSV')))])}
var staticRenderFns = []

export { render, staticRenderFns }